module.exports = __webpack_public_path__ + "static/media/favicon.d41d8cd9.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/favicon.ico
// module id = 874
// module chunks = 0